interface SwallowStatusCodesParams {
  actionDefinedReturn?: unknown;
  statusCodes?: number[];
}

interface ErrorWithStatus {
  status?: number;
  message?: string;
}

export default ({ actionDefinedReturn = {}, statusCodes = [] }: SwallowStatusCodesParams = {}) =>
  (error: ErrorWithStatus = {}) => {
    const { status = 0, message = '' } = error;

    if (!statusCodes.includes(status)) {
      throw message;
    }

    return actionDefinedReturn;
  };
